import React, { useEffect } from "react";

const RedirectToOndemand = () => {
  useEffect(() => {
    window.location.replace(
      `https://ondemand.casadosaber.com.br/cadastro${window.location.search}`
    );
  }, []);

  return <></>;
};

export default RedirectToOndemand;
